import classnames from 'classnames'

export interface EmptyStateProps extends React.HTMLAttributes<HTMLDivElement> {
  action?: React.ReactNode
  description: React.ReactNode
  icon?: React.ReactNode
  title?: React.ReactNode
}

export default function EmptyState({
  action,
  className,
  description,
  icon,
  title,
  ...props
}: EmptyStateProps) {
  return (
    <div
      className={classnames(
        'rounded-2xl border border-dashed border-zinc-200 bg-zinc-50 px-4 py-5 text-sm text-zinc-600',
        className
      )}
      {...props}
    >
      {icon ? <div className="mb-3 text-zinc-400">{icon}</div> : null}
      {title ? <p className="font-semibold text-zinc-900">{title}</p> : null}
      <p className={title ? 'mt-1' : ''}>{description}</p>
      {action ? <div className="mt-4">{action}</div> : null}
    </div>
  )
}
